export function Arrow({ direction = 'diagonal', className = '' }) {
  return (
    <svg className={`arrow arrow-${direction} ${className}`} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 19 19 5M5 5h14v14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function SectionLabel({ number, children, light = false }) {
  return <p className={`section-label${light ? ' section-label-light' : ''}`}><span>{number}</span>{children}</p>;
}
